import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import makeRequest from "../../../../api";
import { trainerService } from "../../../../api/services";
import { toast } from "react-toastify";

const EditRole = () => {
  const params = useParams();
  const roleId = params.roleId;

  const [inputData, setInputData] = useState<{
    roleName: any;
    permissions: any;
  }>({
    roleName: "",
    permissions: [],
  });
  const [permissionsList, setPermissionList] = useState<any>([]);

  const fetchPermissions = async () => {
    try {
      const res = await makeRequest(trainerService.getTrainerPermissionList());
      const arr = res?.data?.body?.permissions?.map((item: any) => ({
        label: `${item?.permissionDisplayName} (${item?.permissionValue})`,
        value: item?.permissionId,
      }));
      setPermissionList([...arr]);
    } catch (error: any) {
      toast.error("Error fetching permissions list!");
    }
  };

  const fetchDetails = async () => {
    try {
      const res = await makeRequest(
        trainerService.getTrainerRoleDetails(roleId)
      );
      const data = res?.data?.body;
      const resData = {
        ...data,
        permissions: data?.permissions?.map((item: any) => ({
          label: `${item?.permissionDisplayName} (${item?.permissionValue})`,
          value: item?.permissionId,
        })),
      };
      setInputData({ ...resData });
    } catch (error: any) {
      toast.error("Error fetching trainer role details!");
    }
  };

  useEffect(() => {
    fetchPermissions();
    fetchDetails();
  }, []);

  const updateRoles = async () => {
    try {
      const data = {
        ...inputData,
        permissions: inputData?.permissions?.map((item: any) => ({
          permissionId: item?.value,
        })),
      };

      const res = await makeRequest(
        trainerService.updateTrainerRole(data, roleId)
      );
      toast.success("Role updated successfully!");
      fetchDetails();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      // console.log(error);
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  const handleSelectChange = (data: any, name: any) => {
    setInputData({ ...inputData, [name]: data });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    updateRoles();
  };

  return (
    <div className="container-lg">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/admin/roles">Roles</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              View or edit
            </li>
          </ol>
        </nav>
      </div>
      <div className="w-50">
        <form onSubmit={handleSubmit}>
          <div className="form-goup mb-4">
            <label className="mb-2" htmlFor="name">
              <strong>Role name</strong>
            </label>
            <input
              type="text"
              name="roleName"
              id="name"
              className="form-control"
              placeholder="Enter role name"
              value={inputData.roleName}
              onChange={handleChange}
            />
          </div>
          <div className="form-goup mb-4">
            <label className="mb-2" htmlFor="value">
              <strong>Permissions</strong>
            </label>
            <Select
              isMulti={true}
              value={inputData?.permissions}
              onChange={(option: any) => {
                handleSelectChange(option, "permissions");
              }}
              name="no_nonveg_days"
              options={permissionsList}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <button className="btn btn-sm btn-outline-success">
            Update role
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditRole;
